const appServer = window.location.origin;
const appPath = process.env.VUE_APP_PATH;
const appUrl = appServer + appPath;

const jwtServer = process.env.VUE_APP_JWT_SERVER || window.location.origin;
const jwtPath = process.env.VUE_APP_JWT_PATH;
const jwtUrl = jwtServer + jwtPath;

const apiServer = process.env.VUE_APP_API_SERVER || window.location.origin;
const apiPath = process.env.VUE_APP_API_PATH;
const apiUrl = apiServer + apiPath;

const socketServer = process.env.VUE_APP_SOCKET_SERVER || window.location.origin;
const socketPath = process.env.VUE_APP_SOCKET_PATH;
const socketUrl = socketServer + socketPath;

const gateServer = process.env.VUE_APP_GATE_SERVER || window.location.origin;
const gatePath = process.env.VUE_APP_GATE_PATH;
const gateUrl = gateServer + gatePath;

const resourceServer = process.env.VUE_APP_RESOURCE_SERVER || window.location.origin;
const resourcePath = process.env.VUE_APP_RESOURCE_PATH;
const resourceUrl = resourceServer + resourcePath;

export default {
  resolve(server) {
    const paths = {};

    switch (server) {
      case 'app':
        paths.server = appServer;
        paths.path = appPath;
        paths.url = appUrl.replace(/\/$/, '');
        break;
      case 'jwt':
        paths.server = jwtServer;
        paths.path = jwtPath;
        paths.url = jwtUrl.replace(/\/$/, '');
        break;
      case 'api':
        paths.server = apiServer;
        paths.path = apiPath;
        paths.url = apiUrl.replace(/\/$/, '');
        break;
      case 'socket':
        paths.server = socketServer;
        paths.path = socketPath;
        paths.url = socketUrl.replace(/\/$/, '');
        break;
      case 'gate':
        paths.server = gateServer;
        paths.path = gatePath;
        paths.url = gateUrl.replace(/\/$/, '');
        break;
      case 'resource':
        paths.server = resourceServer;
        paths.path = resourcePath;
        paths.url = resourceUrl.replace(/\/$/, '');
        break;
      default:
        paths.server = appServer;
        paths.path = appPath;
        paths.url = appUrl.replace(/\/$/, '');
    }

    return paths;
  },
};
